import React from 'react';
import CalendarContainer from '../../UI/organisms/BookingCalendar';
import ModalMessage from '../../UI/organisms/ModalMessage';
import { withTranslation, WithTranslation } from 'next-i18next';
import { Card, CardHeader, CardTitle, CardContent } from '@lb-classroom/ui';
import { X } from 'lucide-react';

interface Tutor {
  id: number;
  name: string;
}

interface CalendarModalOwnProps {
  tutor?: Tutor;
  duration?: number;
  hideModal?: () => void;
  message?: string;
  messageType?: string;
}

type CalendarModalProps = CalendarModalOwnProps & WithTranslation;

const CalendarModal = (props: CalendarModalProps) => {
  const { t, tutor, duration, message, messageType, hideModal } = props;
  const calendarProps = {
    tutor,
    duration,
  };
  return (
    <div className="max-w-lg mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('links.bookQuickly')}</CardTitle>
          <button type="button" className="modal-close" onClick={hideModal}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <CalendarContainer {...calendarProps} />
        </CardContent>
      </Card>
    </div>
  );
};

const wrapped = withTranslation('common')(CalendarModal);

export default wrapped;
